import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import moment from "moment";

import SVG from "../../../components/SVG";
import {
  Button,
  Col,
  Container,
  Modal,
  Row,
  SectionTitle,
  Table
} from "../../../components/simple";
import Header from "../../../components/complex/Header";
import Invite from "../../../components/forms/Auth/Invite";
import TeamRow from "./TeamRow/TeamRow";
import AatarUpload from "./AvatarUpload";
import CompanyDetails from "./CompanyDetails/CompanyDetails";

import Api from "../../../api";

import styles from "./account-profile.module.scss";

class AccountProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowInviteModal: false,
      isShowConfirmModal: false,
      requestError: "",
      selectedProfile: null,
      name: props.user.name,
      isNameEditable: false
    };
    this.nameRef = React.createRef();
  }

  componentDidMount() {
    Api.user.getProfiles();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.user !== this.props.user) {
      this.setState({ name: newProps.user.name });
    }
  }

  handleNameChange = e => {
    this.setState({ name: e.target.value });
  };

  showInviteModal = () => {
    this.setState({ isShowInviteModal: true });
  };

  hideInviteModal = () => {
    this.setState({ isShowInviteModal: false });
  };

  hideConfirmModal = () => {
    this.setState({ isShowConfirmModal: false });
  };

  handleInvite = async ({ emails, role, message }) => {
    try {
      const emailList = emails.filter(email => !!email);
      await Api.user.invite({
        data: {
          role,
          emailList,
          message
        }
      });

      this.hideInviteModal();
    } catch (err) {
      if (err.response) {
        const { data } = err.response;
        this.onInviteError(data);
      } else {
        this.onInviteError("Something went wrong!");
      }
    }
  };

  onInviteError = error => {
    this.setState({ requestError: error });
  };

  removeProfile = teammateId => {
    this.setState({ isShowConfirmModal: true, selectedProfile: teammateId });
  };

  handleChangeRole = (profileId, role) => {
    Api.user.updateProfileRole({ profileId, role }).then(() => {
      Api.user.getProfiles();
    });
  };

  handleProfileRemove = () => {
    Api.user
      .removeProfile({ data: { id: this.state.selectedProfile } })
      .then(() => {
        Api.user.getProfiles();
        this.hideConfirmModal();
      })
      .catch(error => {
        console.error(error);
      });
  };

  renderTitle = () => {
    return (
      <div className={styles.title}>
        <ProfileImage style={{ marginRight: "25px" }} />
        <span>Account settings</span>
      </div>
    );
  };

  render() {
    const { user, profiles } = this.props;
    const {
      name,
      isNameEditable,
      isShowInviteModal,
      isShowConfirmModal,
      requestError
    } = this.state;
    const typeSubscribe = "Expert";
    const curSub = user?.company?.currentSubscription;
    return (
      <Container fluid>
        <Row className={styles["header-wrapper"]}>
          <Container className={styles["header-container"]}>
            <Header titleComponent={this.renderTitle} />
          </Container>
        </Row>
        <Row className={styles.content}>
          <Container className={styles["content-container"]}>
            <Row>
              <Col md={6}>
                <div
                  className={`${styles["section-title"]} ${styles["section-title-details"]}`}
                >
                  <SectionTitle title="Details" />
                </div>
                <div className={styles["details-fields-list"]}>
                  <div className={styles["details-field"]}>
                    <div className={styles["details-field-label"]}>Name</div>
                    <div className={styles["details-field-input-wrapper"]}>
                      <div className={styles["details-field-input-container"]}>
                        <input
                          ref={this.nameRef}
                          className={styles.input}
                          value={name}
                          onChange={this.handleNameChange}
                          disabled={!isNameEditable}
                          onBlur={() => {
                            this.setState({ isNameEditable: false }, () => {
                              // TODO: refactor this
                              Api.user
                                .updateProfile({
                                  id: user.id,
                                  data: {
                                    ...user,
                                    full_name: name,
                                    country: user.country.name
                                  }
                                })
                                .then(() => {
                                  Api.user.getUserInfo({ id: user.id });
                                });
                            });
                          }}
                        />
                      </div>
                      <div
                        className={
                          styles["details-field-edit-button-container"]
                        }
                      >
                        <button
                          type="button"
                          className={styles["details-field-edit-button"]}
                          onClick={() => {
                            this.setState({ isNameEditable: true }, () => {
                              this.nameRef.current.focus();
                            });
                          }}
                        >
                          <SVG.Edit width={15} height={15} />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className={styles["details-field"]}>
                    <div className={styles["details-field-label"]}>Email</div>
                    <div className={styles["details-field-input-wrapper"]}>
                      <div className={styles["details-field-input-container"]}>
                        <input
                          className={styles.input}
                          value={user.email}
                          disabled
                        />
                      </div>
                      {/* <div
                        className={
                          styles["details-field-edit-button-container"]
                        }
                      >
                        <button
                          type="button"
                          className={styles["details-field-edit-button"]}
                        >
                          <SVG.Edit width="15" height="15" />
                        </button>
                      </div> */}
                    </div>
                  </div>
                  <div className={styles["details-field"]}>
                    <div className={styles["details-field-label"]}>
                      Password
                    </div>
                    <div className={styles["details-field-input-wrapper"]}>
                      <div className={styles["details-field-input-container"]}>
                        <input
                          className={styles.input}
                          type="password"
                          value="alexander@gmail.com"
                          disabled
                        />
                      </div>
                      {/* <div
                        className={
                          styles["details-field-edit-button-container"]
                        }
                      >
                        <button
                          type="button"
                          className={styles["details-field-edit-button"]}
                        >
                          <SVG.Edit width="15" height="15" />
                        </button>
                      </div> */}
                    </div>
                  </div>
                  <div
                    className={`
                      ${styles["details-field"]} 
                      ${styles["details-field-date-wrapper"]}
                    `}
                  >
                    <div className={styles["details-field-label"]}>
                      Date registered
                    </div>
                    <div className={styles["details-field-input-container"]}>
                      <span className={styles["details-field-date"]}>
                        {moment(user.dateJoined).format("DD-MM-YY")}
                      </span>
                      <span className={styles["details-field-role"]}>
                        owner
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <AatarUpload photo={user?.profilePhoto} type="profileAvatar" />
              </Col>
            </Row>
            <div className={styles.divider} />
            {(user?.role === "admin" || user?.role === "gdr admin") &&
            typeSubscribe === curSub ? (
              <>
                <CompanyDetails user={user} />
                <div className={styles.divider} />
              </>
            ) : null}
            <Row>
              <Col md={12}>
                <div
                  className={`${styles["section-title"]} ${styles["section-title-team"]}`}
                >
                  <SectionTitle title="Team" />
                  <button
                    type="button"
                    className={`btn ${styles["btn-invite"]}`}
                    onClick={() => {
                      this.showInviteModal();
                    }}
                  >
                    Invite
                  </button>
                </div>
                <div>
                  <Table>
                    <thead>
                      <tr>
                        <th className="teammate">Teammate</th>
                        <th className="permissions">Permissions</th>
                        {user?.role === "admin" ||
                        user?.role === "gdr admin" ? (
                          <th className="delete"></th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {profiles
                        ? profiles.map(profile => (
                            <TeamRow
                              key={profile.id}
                              profile={profile}
                              currentUser={user}
                              onChangeRole={this.handleChangeRole}
                              onRemove={() => this.removeProfile(profile.id)}
                            />
                          ))
                        : null}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
            {/* TODO: Uncomment when implemented
            <div className={styles.divider} />
            <Row>
              <Col md={12}>
                <div className={styles["section-title"]}>
                  <SectionTitle title="Notification" />
                </div>
                <div className={styles["section-notification"]}>
                  <div className={styles["section-notification-row"]}>
                    <div className={styles["section-notification-row-check"]}>
                      <Checkbox onChange={() => {}} idSuffix="1" />
                    </div>
                    <div>
                      <div className={styles["section-notification-row-title"]}>
                        Lectus euismod nunc sed mauris.
                      </div>
                      <div
                        className={
                          styles["section-notification-row-description"]
                        }
                      >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Id augue mi et arcu, magna. Velit aliquet lacus lectus
                        aliquet in sed at vitae venenatis. Faucibus congue id
                        arcu donec amet. Imperdiet eleifend vitae amet ac, ante
                        morbi fusce auctor aliquet.
                      </div>
                    </div>
                  </div>
                  <div className={styles["section-notification-row"]}>
                    <div className={styles["section-notification-row-check"]}>
                      <Checkbox onChange={() => {}} idSuffix="2" checked />
                    </div>
                    <div>
                      <div className={styles["section-notification-row-title"]}>
                        Massa non donec et tristique netus enim commodo.
                      </div>
                      <div
                        className={
                          styles["section-notification-row-description"]
                        }
                      >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Id augue mi et arcu, magna. Velit aliquet lacus lectus
                        aliquet in sed at vitae venenatis.
                      </div>
                    </div>
                  </div>
                  <div className={styles["section-notification-row"]}>
                    <div className={styles["section-notification-row-check"]}>
                      x
                    </div>
                    <div className={styles["section-notification-unsubscribe"]}>
                      <div className={styles["section-notification-row-title"]}>
                        Unsubscribe
                      </div>
                      <div
                        className={
                          styles["section-notification-row-description"]
                        }
                      >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Id augue mi et arcu, magna. Velit aliquet lacus lectus
                        aliquet in sed at vitae venenatis.
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row> */}
            <Modal
              centered
              className={styles["modal-invite"]}
              contentClassName={styles["modal-content"]}
              isOpen={isShowInviteModal}
              toggle={() => {
                this.hideInviteModal();
              }}
            >
              <Invite
                setError={this.onInviteError}
                error={requestError}
                handleSubmit={data => this.handleInvite(data)}
                user={user}
              />
              <SVG.Close
                className={`${styles["close-modal"]}`}
                onClick={() => this.hideInviteModal()}
              />
            </Modal>
            <Modal
              centered
              className={styles["modal-invite"]}
              contentClassName={styles["modal-content"]}
              isOpen={isShowConfirmModal}
              toggle={() => {
                this.hideConfirmModal();
              }}
            >
              <h2 className="title text-center mb-3">Delete Confirmation </h2>
              {/* <p className="description">
                Pulvinar aliquam orci praesent interdum viverra consequat
                volutpat. Sed sit tortor faucibus aliquet fames feugiat.
              </p> */}
              <div className="buttons-container">
                <Button
                  onClick={() =>
                    this.handleProfileRemove(this.state.selectedProfile)
                  }
                  className="button button-danger justify-content-center"
                >
                  Delete Forever
                </Button>
              </div>

              <SVG.Close
                className={`${styles["close-modal"]}`}
                onClick={() => this.hideConfirmModal()}
              />
            </Modal>
          </Container>
        </Row>
      </Container>
    );
  }
}

AccountProfile.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    dateJoined: PropTypes.string,
    country: PropTypes.shape({ name: PropTypes.string }),
    role: PropTypes.string,
    profilePhoto: PropTypes.string,
    company: PropTypes.shape({
      currentSubscription: PropTypes.string
    })
  }).isRequired,
  profiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

const mapStateToProps = ({ userProfile }) => {
  return {
    user: userProfile.user,
    profiles: userProfile.profiles
  };
};

export default connect(mapStateToProps, null)(AccountProfile);

const ProfileImage = props => {
  return (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 0C7.36076 0 4.4 3.05717 4.4 6.8149C4.4 10.5726 7.36076 13.6298 11 13.6298C14.6392 13.6298 17.6 10.5726 17.6 6.8149C17.6 3.05717 14.6392 0 11 0Z"
        fill="#063AC9"
      />
      <path
        d="M19.2117 18.082C17.4047 16.1875 15.0093 15.1442 12.4667 15.1442H9.53333C6.99072 15.1442 4.59526 16.1875 2.78833 18.082C0.990244 19.9671 0 24.6094 0 27.2428C0 27.661 0.328338 28 0.733333 28H21.2667C21.6717 28 22 27.661 22 27.2428C22 24.6094 21.0098 19.9671 19.2117 18.082Z"
        fill="#063AC9"
      />
    </svg>
  );
};
